const initState = {
    selectedArea: '',
    selectedQuestion: 0,
    totalQuestions: 15,
    testsDone: 0,
    showSurvey: false,
    selectedSummaryArea: '',
    selectedSummaryQuestion: '',
    showTutorial: true
};

const globals = (state = initState, action) => {
    switch (action.type) {
        case 'SELECT_SUBJECT':
            return {
                ...state,
                selectedArea: action.area,
                totalQuestions: action.total,
                selectedQuestion: 0,
                showAreas: false,
                showQuestion: true,
            };
        case 'SELECT_QUESTION':
            return {
                ...state,
                selectedQuestion: action.value,
            };
        case 'SHOW_SURVEY':
            return {
                ...state,
                showSurvey: true,
            };
        case 'SHOW_SUMMARY_AREA':
            return {
                ...state,
                selectedSummaryArea: action.area,
                selectedSummaryQuestion: action.question,
            };
        case 'SHOW_SUMMARY_QUESTION':
            return {
                ...state,
                selectedSummaryQuestion: action.question,
            };
        case 'SHOW_TUTORIAL':
            return {
                ...state,
                showTutorial: action.showTutorial,
            };
        case 'MAKE_TEST_DONE':
            return {
                ...state,
                testsDone: state.testsDone + 1,
            };
        default:
            return state;
    }
};

export default globals;



// WEBPACK FOOTER //
// ./sources/js/reducers/globalsReducer.js